import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { Api } from 'src/smoothr-web-app-core/api/api';
import Customer from 'src/smoothr-web-app-core/models/Customer';
import Order from 'src/smoothr-web-app-core/models/Order';
import Venue from 'src/smoothr-web-app-core/models/Venue';

@Component({
	selector: 'app-show-history-points',
	templateUrl: './show-history-points.component.html',
	styleUrls: ['./show-history-points.component.scss'],
})
export class ShowHistoryPointsComponent implements OnInit {
	order: Order;
	venue: Venue;
	customer: Customer;
	months: string[] = [];
	ordersByMonth: {
		[month: string]: {
			credits: number;
			shop: { name: string };
			created_at: string;
		}[];
	} = {};
	loading = false;
	loadMore = false;
	lastPage = 0;
	constructor(
		private modalCtrl: ModalController,
		private translate: TranslateService
	) {}
	static async show(modalCtrl: ModalController, order: Order, customer: Customer, venue: Venue) {
		const modal = await modalCtrl.create({
			component: ShowHistoryPointsComponent,
			cssClass: ' item-modal',
			componentProps: {
				order,
				customer,
				venue,
			},
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
		await modal.onDidDismiss();
	}
	async ngOnInit() {
		await this.loadAllHistoryPoints();
	}

	async loadAllHistoryPoints(page: number = 1) {
		this.loading = true;
		try {
			if (this.order?.venue ?? this.venue?._id) {
				const result = (await Api.loyaltyHistoryPiggy(this.order?.venue ?? this.venue?._id, '', this.customer.piggyUuid, page))
					.data as any;
				if (result.data) {
					this.groupByMonth(result.data);
				}
				this.loadMore = false;
				if (result?.meta?.page === 1 && result?.meta?.last_page > 1) {
					this.lastPage = result?.meta?.last_page;
					this.loadMore = true;
					this.loadAllHistoryPoints(result?.meta?.last_page);
				}
			}
			// const result = await Api.getLoyaltyHistory(this.customer.uid);

			this.loading = false;
		} catch (e) {
			this.loading = false;
		}
	}

	groupByMonth(statistic: { credits: number; shop: { name: string }; created_at: string }[]) {
		// Group orders by month
		console.log(statistic);
		if (statistic) {
			statistic.forEach(order => {
				const month = moment(order.created_at).format('MMMM yyyy');

				if (!this.ordersByMonth[month]) {
					this.ordersByMonth[month] = [];
					this.months.push(month);
				}

				this.ordersByMonth[month].push(order);
			});

			// Sort months in descending order
			this.months.sort((a, b) => moment(b, 'MMMM yyyy').diff(moment(a, 'MMMM yyyy')));

			//Sort order in descending order
			this.months.forEach(month => {
				this.ordersByMonth[month].sort((a, b) => moment(b.created_at).diff(moment(a.created_at)));
			});
		}
	}

	dismiss() {
		this.modalCtrl.dismiss();
	}
}
